import styled from 'styled-components';

const Button = styled.button.attrs({
    type: 'button',
})`
    background-color: inherit;
    color: inherit;
    font: inherit;
    padding: 5px 8px;
    cursor: pointer;
    border: 1px solid lightgrey;
    outline: none;

    &:hover {
        background-color: #e6e4e4;
    }
`;

const ActiveButton = styled(Button)`
    background-color: #0c444d;
    color: white;
    font-weight: normal;

    &:hover {
        background-color: #095e6b;
    }
`;

export { Button, ActiveButton };
